export default __webpack_public_path__ + "static/media/Group1766.80e8c7b9.svg";